import { apiGet, apiPost, apiPatch } from './client';

export interface Notification {
  id: string;
  title: string;
  body: string;
  data?: Record<string, any>;
  sentAt: string;
  read: boolean;
  readAt?: string | null;
}

export interface NotificationsResponse {
  notifications: Notification[];
  total: number;
  unread: number;
  limit: number;
  skip: number;
}

export interface NotificationsCount {
  total: number;
  unread: number;
}

export const NotificationsAPI = {
  async getMyNotifications(options?: {
    limit?: number;
    skip?: number;
    unreadOnly?: boolean;
  }): Promise<NotificationsResponse> {
    const params = new URLSearchParams();
    if (options?.limit) params.append('limit', options.limit.toString());
    if (options?.skip) params.append('skip', options.skip.toString());
    if (options?.unreadOnly) params.append('unreadOnly', 'true');

    const queryString = params.toString();
    const url = queryString ? `/notifications/me?${queryString}` : '/notifications/me';

    return apiGet(url);
  },

  async getMyNotificationsCount(): Promise<NotificationsCount> {
    return apiGet('/notifications/me/count');
  },

  async markAsRead(notificationId: string): Promise<Notification> {
    return apiPatch(`/notifications/${notificationId}/read`);
  },

  async markAllAsRead(): Promise<{ message: string; modifiedCount: number }> {
    return apiPost('/notifications/read-all');
  },
};
